import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5710a140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-layout" }
const _hoisted_2 = { class: "settings-layout-menu" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Uživatelé")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Detail uživatele ")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Nový uživatel")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Nastavení API")
const _hoisted_9 = { class: "settings-layout-content" }

import AuthorizedLayout from '@/layouts/AuthorizedLayout.vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(AuthorizedLayout, { title: "Nastavení" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/nastaveni/uzivatele" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            (_unref(route).params.id)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: `/nastaveni/uzivatel/${_unref(route).params.id}`
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            (_unref(route).path === '/nastaveni/novy-uzivatel')
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createVNode(_component_router_link, { to: "/nastaveni/novy-uzivatel" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/nastaveni/api" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_view)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})